// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Footer_componentWrapper__j7hZh","socials":"Footer_socials__Xh9JH","icon":"Footer_icon__Pol7P","isHomePage":"Footer_isHomePage__cEMay"};